export function alignChat(position) {
  switch (position) {
    case 'up':
      return document.body.classList.add('chat-align-up')
    case 'left':
      return document.body.classList.add('chat-align-left')
    default:
      return document.body.classList.remove('chat-align-up', 'chat-align-left')
  }
}
